export function getSkillDisplayName(skill) {
    return skill.display_name || skill.name;
}
export function getSkillDisplayDescription(skill) {
    return skill.display_description || skill.description;
}
//# sourceMappingURL=skillDisplay.js.map